.dropdown {
    composes: dropdown from './Dropdown.module.css';
    --popover-border-color: var(--mantine-color-default-border);
    --popover-shadow: var(--mantine-shadow-md);
    padding: rem(4px);
    /* Lightbox glass: translucent fill, blur + saturate, hairline highlight. */
    border-color: light-dark(rgb(255 255 255 / 65%), rgb(255 255 255 / 10%));
    background-color: light-dark(rgb(255 255 255 / 72%), rgb(30 31 34 / 72%));
    box-shadow:
        0 10px 32px rgb(0 0 0 / 12%),
        inset 0 1px 0 light-dark(rgb(255 255 255 / 70%), rgb(255 255 255 / 6%));
    -webkit-backdrop-filter: blur(16px) saturate(1.7);
    backdrop-filter: blur(16px) saturate(1.7);
}

.option {
    border-radius: var(--mantine-radius-sm);
    padding: rem(6px) rem(8px);
    line-height: var(--mantine-line-height-sm);
}

/* Keyboard / hover highlight: a quiet fill, not the primary color. */
.option[data-combobox-selected] {
    background-color: var(--mantine-color-default-hover);
    color: var(--mantine-color-text);
}

.option[data-combobox-disabled] {
    color: var(--mantine-color-disabled-color);
}

.groupLabel {
    font-size: var(--mantine-font-size-xs);
    font-weight: 500;
    color: var(--mantine-color-dimmed);
}

.groupLabel::after {
    display: none;
}

.empty {
    color: var(--mantine-color-dimmed);
    font-size: var(--mantine-font-size-sm);
    padding: rem(8px);
}

.header,
.footer {
    border-color: var(--mantine-color-default-border);
}

@supports not (backdrop-filter: blur(1px)) {
    .dropdown {
        background-color: var(--mantine-color-body);
    }
}

@media (prefers-reduced-transparency: reduce) {
    .dropdown {
        background-color: var(--mantine-color-body);
        -webkit-backdrop-filter: none;
        backdrop-filter: none;
    }
}
